/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  BatchNotificationRequest,
  BatchNotificationResponse,
  Email,
  MapString,
  NotificationStatusRequest,
  NotificationStatusResponse,
  SettingRequest,
  SettingsStatusResponse,
} from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V1<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "notifications";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * @description Lists details of a batch of notifications. read-only.
   *
   * @tags Notifications
   * @name ListNotifications
   * @request POST:/v1/tenant/{tenantId}/notificationsStatus
   * @secure
   */
  listNotifications = (tenantId: string, data: NotificationStatusRequest, params: RequestParams = {}) =>
    this.request<
      NotificationStatusResponse,
      | Email
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/notificationsStatus`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listNotifications */
  listNotificationsPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/notificationsStatus`);

  /**
   * @description Lists all settings of notifications. read-only.
   *
   * @tags Notifications
   * @name Settings
   * @request GET:/v1/tenant/{tenantId}/settings
   * @secure
   */
  settings = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      SettingsStatusResponse,
      | Email
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/settings`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for settings */
  settingsPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/settings`);

  /**
   * @description Set settings of notifications. read-only.
   *
   * @tags Notifications
   * @name Settings2
   * @request POST:/v1/tenant/{tenantId}/settings
   * @originalName settings
   * @duplicate
   * @secure
   */
  settings2 = (tenantId: string, data: SettingRequest, params: RequestParams = {}) =>
    this.request<
      SettingsStatusResponse,
      | Email
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/settings`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for settings2 */
  settings2PathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/settings`);

  /**
   * @description Schedules a batch of notifications
   *
   * @tags Notifications
   * @name ScheduleNotifications
   * @request POST:/v1/tenant/{tenantId}/scheduleNotifications
   * @secure
   */
  scheduleNotifications = (tenantId: string, data: BatchNotificationRequest, params: RequestParams = {}) =>
    this.request<
      BatchNotificationResponse,
      | Email
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/scheduleNotifications`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for scheduleNotifications */
  scheduleNotificationsPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/scheduleNotifications`);
}
